// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"css3"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M3 2H21L20 19.5L12 22.5L4 19.5L3 2Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M3 2H21L20 19.5L12 22.5L4 19.5L3 2Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M7.26589 15.4094L7.24779 15.0734H7.24969L7.26589 15.4094ZM7.26589 15.4094L7.3427 16.7536L11.9997 18.5L16.6566 16.7537L16.9638 11.3768L7.03546 11.3768L7.02192 11.14L17.2574 6.24001L17.2711 6H11.9997M11.9997 6L6.62338 6.00999L6.62207 6H11.9997Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Css3Icon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'css3',
    ref,
    icon: element,
  },
));

Css3Icon.displayName = 'Css3Icon';

export default Css3Icon;
